import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/components/app.layout').then((c) => c.AppLayout),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'companies',
        loadComponent: () =>
          import('./pages/companies/companies.component').then((m) => m.CompaniesComponent),
      },
      {
        path: 'companies/:companyId/stores',
        loadComponent: () =>
          import('./pages/stores/stores.component').then((m) => m.StoresComponent),
      },
      {
        path: 'stores',
        loadComponent: () =>
          import('./pages/stores/stores.component').then((m) => m.StoresComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'plans',
        loadComponent: () => import('./pages/plans/plans.component').then((m) => m.PlansComponent),
      },
      {
        path: 'features',
        loadComponent: () =>
          import('./pages/features/features.component').then((m) => m.FeaturesComponent),
      },
      {
        path: 'reasons',
        loadComponent: () =>
          import('./pages/reasons/reasons.component').then((m) => m.ReasonsComponent),
      },
      {
        path: 'material-types',
        loadComponent: () =>
          import('./pages/material-types/material-types.component').then(
            (m) => m.MaterialTypesComponent,
          ),
      },
      {
        path: 'model-pricing',
        loadComponent: () =>
          import('./pages/model-pricing/model-pricing.component').then(
            (m) => m.ModelPricingComponent,
          ),
      },
      {
        path: 'evaluation-types',
        loadComponent: () =>
          import('./pages/evaluation-types/evaluation-types.component').then(
            (m) => m.EvaluationTypesComponent,
          ),
      },
      {
        path: 'evaluations',
        loadComponent: () =>
          import('./pages/evaluations/evaluations.component').then((m) => m.EvaluationsComponent),
      },
      {
        path: 'evaluations/:id',
        loadComponent: () =>
          import('./pages/evaluations/evaluation-detail/evaluation-detail.component').then(
            (m) => m.EvaluationDetailComponent,
          ),
      },
      {
        path: 'playground',
        loadComponent: () =>
          import('./pages/playground/playground.component').then((m) => m.PlaygroundComponent),
      },
      {
        path: 'cost-calculator',
        loadComponent: () =>
          import('./pages/cost-calculator/cost-calculator.component').then(
            (m) => m.CostCalculatorComponent,
          ),
      },
      {
        path: 'billing',
        loadChildren: () => import('./pages/billing/billing.routes').then((m) => m.BILLING_ROUTES),
      },
      {
        path: 'whatsapp',
        children: [
          {
            path: 'templates',
            loadComponent: () =>
              import('./pages/whatsapp/whatsapp-list/whatsapp-list.component').then(
                (m) => m.WhatsappListComponent,
              ),
          },
          {
            path: 'variables',
            loadComponent: () =>
              import('./pages/whatsapp/variable-list/variable-list.component').then(
                (m) => m.VariableListComponent,
              ),
          },
          {
            path: 'templates/new',
            loadComponent: () =>
              import('./pages/whatsapp/template-editor/template-editor.component').then(
                (m) => m.TemplateEditorComponent,
              ),
          },
          {
            path: 'templates/:id/edit',
            loadComponent: () =>
              import('./pages/whatsapp/template-editor/template-editor.component').then(
                (m) => m.TemplateEditorComponent,
              ),
          },
          {
            path: 'triggers',
            loadComponent: () =>
              import('./pages/whatsapp/trigger-list/trigger-list.component').then(
                (m) => m.TriggerListComponent,
              ),
          },
          {
            path: 'observability',
            loadComponent: () =>
              import('./pages/whatsapp/whatsapp-observability/whatsapp-observability.component').then(
                (m) => m.WhatsappObservabilityComponent,
              ),
          },
          { path: '', redirectTo: 'templates', pathMatch: 'full' },
        ],
      },
      {
        path: 'prompts/new',
        loadComponent: () =>
          import('./pages/prompts/prompt-editor/prompt-editor.component').then(
            (m) => m.PromptEditorComponent,
          ),
      },
      {
        path: 'prompts/:id/edit',
        loadComponent: () =>
          import('./pages/prompts/prompt-editor/prompt-editor.component').then(
            (m) => m.PromptEditorComponent,
          ),
      },
      {
        path: 'prompts',
        loadComponent: () =>
          import('./pages/prompts/prompts-list/prompts-list.component').then(
            (m) => m.PromptsListComponent,
          ),
      },
      {
        path: 'prompt-variables',
        loadComponent: () =>
          import('./pages/prompt-variables/prompt-variables.component').then(
            (m) => m.PromptVariablesComponent,
          ),
      },
      {
        path: 'credit-purchases',
        loadComponent: () =>
          import('./pages/credit-purchases/credit-purchases.component').then(
            (m) => m.CreditPurchasesComponent,
          ),
      },
      {
        path: 'credit-statement',
        loadComponent: () =>
          import('./pages/credit-statement/credit-statement.component').then(
            (m) => m.CreditStatementComponent,
          ),
      },
      {
        path: 'credits',
        loadComponent: () =>
          import('./pages/credits/credits-list/credits-list.component').then(
            (m) => m.CreditsListComponent,
          ),
      },
      {
        path: 'credits/:companyId/transactions',
        loadComponent: () =>
          import('./pages/credits/credit-transactions/credit-transactions.component').then(
            (m) => m.CreditTransactionsComponent,
          ),
      },
      {
        path: 'observability',
        loadComponent: () =>
          import('./pages/observability/observability.component').then(
            (m) => m.ObservabilityComponent,
          ),
      },
      {
        path: 'costs',
        loadComponent: () => import('./pages/costs/costs.component').then((m) => m.CostsComponent),
      },
      {
        path: 'alerts',
        loadComponent: () =>
          import('./pages/alerts/alerts.component').then((m) => m.AlertsComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
